/* ============================================================
   YOUNGER — How it works page logic
   (why-stats count-up + why statement typewriter)
   ============================================================ */
(function(){
  // 語系：<html lang> 由 theme.liquid 依 request.locale.iso_code 輸出
  var IS_EN = /^en/i.test(document.documentElement.getAttribute('lang') || '');
  var HW = IS_EN
    ? { alr:'Priority', cau:'Worth watching', opt:'Looking good',
        risk_title:'Risk Ranking', cats:function(n){ return n + ' categories'; },
        more:function(n){ return '+ ' + n + ' more categories tracked'; },
        l1:'We start before symptoms appear.', l2:'That is the difference.' }
    : { alr:'\u512a\u5148\u95dc\u6ce8', cau:'\u5efa\u8b70\u7559\u610f', opt:'\u76ee\u524d\u826f\u597d',
        risk_title:'\u98a8\u96aa\u6392\u5e8f', cats:function(n){ return n + ' \u9805\u5206\u985e'; },
        more:function(n){ return '\uff0b\u5176\u9918 ' + n + ' \u9805\u5206\u985e\u6301\u7e8c\u8ffd\u8e64'; },
        l1:'\u6211\u5011\u5728\u75c7\u72c0\u51fa\u73fe\u524d\u5c31\u958b\u59cb\u3002', l2:'\u9019\uff0c\u5c31\u662f\u5dee\u5225\u3002' };

  /* ---------- reveal on scroll (.reveal → .in)；本頁未載 bd-home.js，需自帶 ---------- */
  (function(){
    var els = document.querySelectorAll('.hiwx .reveal');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var ro = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); ro.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function(el){ ro.observe(el); });
  })();

  /* ---------- why-stats count-up on reveal ---------- */
  const statWrap = document.querySelector('.why-stats');
  if(statWrap){
    const nums = [...statWrap.querySelectorAll('.wstat-v')].map(el=>{
      const m = el.textContent.match(/^(\d+)(.*)$/);
      return { el, target: m?+m[1]:0, suffix: m?m[2]:'' };
    });
    nums.forEach(n=>{ n.el.textContent = '0' + n.suffix; });
    const ease = t => 1 - Math.pow(1 - t, 3);
    const run = () => {
      const dur = 1100, t0 = performance.now();
      const tick = now => {
        const p = Math.min(1, (now - t0) / dur), e = ease(p);
        nums.forEach(n=>{ n.el.textContent = Math.round(n.target * e) + n.suffix; });
        if(p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){ nums.forEach(n=>{ n.el.textContent = n.target + n.suffix; }); }
    else{
      const sObs = new IntersectionObserver(es=>{
        es.forEach(e=>{ if(e.isIntersecting){ run(); sObs.disconnect(); } });
      },{threshold:0.5});
      sObs.observe(statWrap);
    }
  }

  /* ---------- why statement typewriter on reveal ---------- */
  const whyType = document.getElementById('whyType');
  if(whyType){
    const l1 = whyType.querySelector('.tl1'), l2 = whyType.querySelector('.tl2');
    const t1 = whyType.dataset.l1 || HW.l1, t2 = whyType.dataset.l2 || HW.l2;
    const caret = document.createElement('span'); caret.className = 'type-caret';
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){ l1.textContent = t1; l2.textContent = t2; l2.appendChild(caret); }
    else{
      const typeInto = (el, text, cb) => {
        let i = 0;
        (function tick(){
          el.textContent = text.slice(0, i);
          el.appendChild(caret);
          if(i < text.length){ i++; setTimeout(tick, 85); }
          else if(cb) setTimeout(cb, 450);
        })();
      };
      const start = () => typeInto(l1, t1, () => typeInto(l2, t2));
      const tObs = new IntersectionObserver(es=>{
        es.forEach(e=>{ if(e.isIntersecting){ start(); tObs.disconnect(); } });
      },{threshold:0.4});
      tObs.observe(whyType);
    }
  }

  /* ---------- bio-network (step 01) ---------- */
  const bionet = document.getElementById('bionet');
  if(bionet){
    const core = document.getElementById('bnCore');
    const nodesWrap = document.getElementById('bnNodes');
    const linksSvg = document.getElementById('bnLinks');
    const hint = document.getElementById('bnHint');
    // marker names across systems; depth: 0=near/sharp ... 2=far/blurred
    const items = [
      ['空腹血糖',0],['糖化血色素',1],['胰島素',2],['總膽固醇',0],['HDL',1],['LDL',2],
      ['三酸甘油酯',0],['GOT',1],['GPT',2],['肌酸酐',0],['尿酸',1],['CRP',0],
      ['維生素 D',1],['鐵蛋白',2],['TSH',0],['游離 T4',1],['同半胱胺酸',2],['白蛋白',1],
      ['鈉',2],['鉀',2],['鈣',1],['鎂',2],['Omega-3',0],['葉酸',1]
    ];
    // i18n：節點名來自 data-markers（locale），順序對齊 items；缺項 fallback 回中文預設
    const tnames = (bionet.dataset.markers || '').split(',').map(s=>s.trim());
    const depthCfg = [
      {blur:'0px', fs:'12px', op:1,    amp:'-7px'},   // near
      {blur:'1.4px', fs:'11px', op:.82, amp:'5px'},   // mid
      {blur:'3.4px', fs:'10px', op:.55, amp:'-4px'}   // far
    ];
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // ring layout: near=inner, far=outer (kept < core radius reach so nothing dwarfs the core)
    const ringR = [24, 34, 43]; // % of container
    const built = [];
    const cx = 62, cy = 50, aspect = 0.82; // network centred right of middle, trailing left for depth
    items.forEach(([name,depth],i)=>{
      const cfg = depthCfg[depth];
      const ring = ringR[depth];
      const perRing = depth===0?7:depth===1?8:9;
      const idxInRing = built.filter(b=>b.depth===depth).length;
      const ang = (idxInRing/perRing)*Math.PI*2 + depth*0.6 + 0.5; // bias spread toward the left
      const x = cx + Math.cos(ang)*ring;
      const y = cy + Math.sin(ang)*ring*aspect;
      const el = document.createElement('div');
      el.className = 'bn-node';
      el.style.cssText = `--x:${x}%;--y:${y}%;--blur:${cfg.blur};--fs:${cfg.fs};--op:${cfg.op};--amp:${cfg.amp};--d:${(i%8)*0.04}s;--fl:${(3.2+ (i%5)*0.4).toFixed(1)}s;`;
      el.style.zIndex = depth===0?3:depth===1?2:1;
      el.textContent = (tnames[i] && tnames[i].length) ? tnames[i] : name;
      nodesWrap.appendChild(el);
      built.push({x,y,depth});
    });
    // links from core to near+mid nodes
    if(linksSvg){
      linksSvg.innerHTML = built.map(b=> b.depth<2
        ? `<line x1="${cx}" y1="${cy}" x2="${b.x.toFixed(1)}" y2="${b.y.toFixed(1)}" stroke="rgba(255,255,255,${b.depth===0?0.4:0.22})" stroke-width="${b.depth===0?0.5:0.35}" vector-effect="non-scaling-stroke"/>`
        : '').join('');
    }
    // 預設只顯示核心；點擊一次後展開節點並保持漂浮狀態（不收合）
    const open = () => { bionet.dataset.state = 'open'; };
    if(reduce){
      open();
    } else {
      bionet.addEventListener('click', open, { once: true });
    }
  }

  /* ---------- step 02: six-system bars + score count-up ---------- */
  const sysCard = document.getElementById('sysCard');
  if(sysCard){
    const scoreEl = document.getElementById('sysScore');
    const reduce2 = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const countScore = () => {
      if(reduce2){ scoreEl.textContent = '68'; return; }
      const t0 = performance.now(), dur = 1200;
      const tick = now => {
        const p = Math.min(1, (now - t0)/dur), e = 1 - Math.pow(1-p,3);
        scoreEl.textContent = Math.round(68 * e);
        if(p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if(reduce2){ sysCard.classList.add('in'); scoreEl.textContent = '68'; }
    else{
      const io2 = new IntersectionObserver(es=>{
        es.forEach(e=>{ if(e.isIntersecting){ sysCard.classList.add('in'); countScore(); io2.disconnect(); } });
      },{threshold:0.4});
      io2.observe(sysCard);
    }
  }

  /* ---------- step 03: timeline track (appear → pause → push → new point → dash) ---------- */
  const trackCard = document.getElementById('trackCard');
  if(trackCard){
    const reduce3 = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce3){ trackCard.classList.add('in','shift','show-new','show-dash'); }
    else{
      const io3 = new IntersectionObserver(es=>{
        es.forEach(e=>{ if(e.isIntersecting){
          trackCard.classList.add('in');                                  // 1: four dots appear
          setTimeout(()=>trackCard.classList.add('shift'), 1900);         // 2: pause, then push forward
          setTimeout(()=>trackCard.classList.add('show-new'), 2700);      // 3: fifth dot + New badge
          setTimeout(()=>trackCard.classList.add('show-dash'), 3300);     // 4: dashed extension
          io3.disconnect();
        }});
      },{threshold:0.4});
      io3.observe(trackCard);
    }
  }

  /* ---------- step 04: trend chart draw-in ---------- */
  const chartCard = document.getElementById('chartCard');
  if(chartCard){
    const line = document.getElementById('chartLine');
    if(line){ const len = line.getTotalLength(); line.style.setProperty('--len', Math.ceil(len)); }
    const reduce4 = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce4){ chartCard.classList.add('in'); }
    else{
      const io4 = new IntersectionObserver(es=>{
        es.forEach(e=>{ if(e.isIntersecting){ chartCard.classList.add('in'); io4.disconnect(); } });
      },{threshold:0.4});
      io4.observe(chartCard);
    }
  }

  /* ---------- step 02: 風險排序卡（依數值由高到低排序，逐列浮現）---------- */
  const risk = document.getElementById('riskCard');
  if(risk && !risk.dataset.built){
    risk.dataset.built = '1';
    const total = parseInt(risk.dataset.total, 10) || 0;
    const show  = parseInt(risk.dataset.show, 10) || 5;
    const items = (risk.dataset.items || '').split('\n').map(l=>l.trim()).filter(Boolean)
      .map(l=>{ const p=l.split('|'); return { lab:(p[0]||'').trim(), num:parseInt((p[1]||'').trim(),10)||0 }; })
      .filter(it=>it.lab)
      .sort((a,b)=>b.num-a.num);
    const top = items.slice(0, show);
    if(top.length){
      // 分級：65↑ 優先關注 / 40–64 建議留意 / 40↓ 目前良好
      const level = n => n>=65 ? ['alr',HW.alr] : (n>=40 ? ['cau',HW.cau] : ['opt',HW.opt]);
      const mk = (tag, cls, txt) => { const e=document.createElement(tag); if(cls) e.className=cls; if(txt!=null) e.textContent=txt; return e; };

      const head = mk('div','hvr-head');
      head.appendChild(mk('span','hvr-title', risk.dataset.title || HW.risk_title));
      if(total) head.appendChild(mk('span','hvr-total', HW.cats(total)));
      risk.appendChild(head);

      top.forEach((it,i)=>{
        const [cls,txt] = level(it.num);
        const row = mk('div','hvr-row');
        row.style.setProperty('--d', (0.08 + i*0.1).toFixed(2) + 's');
        row.appendChild(mk('span','hvr-rank', String(i+1).padStart(2,'0')));
        row.appendChild(mk('span','hvr-name', it.lab));
        const bar = mk('span','hvr-bar'), fill = mk('i','b-'+cls);
        fill.style.setProperty('--w', Math.max(6, Math.min(100, it.num)) + '%');
        bar.appendChild(fill); row.appendChild(bar);
        row.appendChild(mk('span','hvr-lv lv-'+cls, txt));
        risk.appendChild(row);
      });

      // 手機只顯示 3 列（畫面較滿），「其餘 N 項」的 N 隨之調整
      const rowEls = Array.prototype.slice.call(risk.querySelectorAll('.hvr-row'));
      const more = mk('div','hvr-more'), moreTxt = mk('span', null, '');
      more.appendChild(moreTxt); risk.appendChild(more);
      const mqNarrow = window.matchMedia('(max-width:900px)');
      function applyVisible(){
        const vis = mqNarrow.matches ? Math.min(3, rowEls.length) : rowEls.length;
        rowEls.forEach((el,i)=>{ el.style.display = i < vis ? '' : 'none'; });
        const rest = total - vis;
        more.style.display = rest > 0 ? '' : 'none';
        moreTxt.textContent = HW.more(rest);
      }
      if(mqNarrow.addEventListener) mqNarrow.addEventListener('change', applyVisible);
      else if(mqNarrow.addListener) mqNarrow.addListener(applyVisible);
      applyVisible();

      if('IntersectionObserver' in window){
        const ior=new IntersectionObserver((es,ob)=>{ es.forEach(e=>{ if(e.isIntersecting){ risk.classList.add('in'); ob.disconnect(); } }); },{threshold:0.3});
        ior.observe(risk);
      } else { risk.classList.add('in'); }
    }
  }

  /* ---------- 浮標膠囊：打字循環（第一句固定，之後隨機抽檢測項目）---------- */
  document.querySelectorAll('.hiwx .hv-chip[data-typeloop]').forEach(chip=>{
    const txtEl = chip.querySelector('.hv-chip-txt');
    if(!txtEl) return;
    const base = (txtEl.textContent || '').trim();
    if(!base) return;

    const suffix = chip.dataset.loopSuffix || '';
    const items = (chip.dataset.loopItems || '').split('\n')
      .map(v=>v.trim()).filter(Boolean).map(v=>v + suffix);

    // 逐句量寬：句子長度差很多（「尿酸分析中...」vs「腫瘤多胜酶抗原 TPA分析中...」），
    // 若不先撐開，膠囊會隨每個字改變寬度而抖動。改成換句時一次過渡到該句寬度。
    const ruler = document.createElement('span');
    ruler.setAttribute('aria-hidden','true');
    const cs = getComputedStyle(txtEl);
    ruler.style.cssText = 'position:absolute;left:-9999px;top:0;white-space:pre;visibility:hidden;'
      + 'font:' + cs.font + ';letter-spacing:' + cs.letterSpacing + ';';
    document.body.appendChild(ruler);
    const widthOf = str => { ruler.textContent = str; return Math.ceil(ruler.getBoundingClientRect().width); };

    txtEl.style.minWidth = widthOf(base) + 'px';
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches){
      ruler.remove(); return;                       // 減少動態效果：維持靜態文字
    }

    let phrase = base, i = 0, dir = 1, first = true;
    txtEl.textContent = '';
    txtEl.style.minWidth = widthOf(base) + 'px';

    function nextPhrase(){
      if(first){ first = false; return base; }      // 第一句固定用設定值
      if(!items.length) return base;
      let pick = phrase;
      for(let n = 0; n < 8 && pick === phrase; n++){ // 避免連兩次抽到同一項
        pick = items[Math.floor(Math.random() * items.length)];
      }
      return pick;
    }

    (function tick(){
      i += dir;
      txtEl.textContent = phrase.slice(0, i);
      let wait = dir > 0 ? 120 : 45;
      if(dir > 0 && i >= phrase.length){ dir = -1; wait = 1600; }          // 打完停一下
      else if(dir < 0 && i <= 0){
        dir = 1; wait = 420;
        phrase = nextPhrase();
        txtEl.style.minWidth = widthOf(phrase) + 'px';                     // 先撐開再打字
      }
      setTimeout(tick, wait);
    })();
  });
})();
